export default "__VITE_ASSET__BBVbWcBk__$_?component__"